import { Injectable, InjectionToken } from '@angular/core';
import { ModalSpinnerService } from '@reef/core';
import { BehaviorSubject } from 'rxjs';

export const LOADING_SERVICE = new InjectionToken<LoadingService>('Loading Service');

@Injectable({providedIn: 'root'})
export class LoadingService {
  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();
  private busyCounter = 0;

  constructor(private readonly modalSpinnerService: ModalSpinnerService) {
  }

  /**
   * Add one to the busy stack. Displays the spinner and emits loading true value
   * when transitioning from idle to busy state
   */
  increment() {
    if (!this.busyCounter) {
      this.modalSpinnerService.displaySpinner();
      this.isLoadingSubject.next(true);
    }
    this.busyCounter++;
  }

  /**
   * Subtracts one to the busy stack. Hides the spinner and emits loading false value
   * when transitioning from busy to idle state
   */
  decrement() {
    if (this.busyCounter) {
      this.busyCounter--;
    }

    if (!this.busyCounter) {
      this.modalSpinnerService.hideSpinner();
      this.isLoadingSubject.next(false);
    }
  }
}
